module.exports = __webpack_public_path__ + "img/__icon_CYSTERNA_PALIWOWA.faf58df6.svg";